import { createSlice } from "@reduxjs/toolkit";
import { AibleClientFactory } from "client/aible/factory";
import * as globalReducer from "containers/App/reducer";
import { getSelectedAccountId } from "@/containers/Accounts/reducer";
import * as accountsReducer from "@/containers/Accounts/reducer";
const client = AibleClientFactory.getInstance().getContentGenerationClient();
function updateStateWithCollection(state, action) {
    const collectionExecutions = action.executions.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
    }, {});
    return {
        ...state,
        collections: {
            ...state.collections,
            [action.id]: action
        },
        executions: {
            ...state.executions,
            ...collectionExecutions
        }
    };
}
function deleteCollectionFromState(state, id) {
    const newState = {
        ...state,
        collections: {
            ...state.collections
        }
    };
    delete newState.collections[id];
    return newState;
}
function updateStateWithExampleSet(state, action) {
    return {
        ...state,
        exampleSets: {
            ...state.exampleSets,
            [action.id]: action
        }
    };
}
function deleteExampleSetFromState(state, id) {
    const newState = {
        ...state,
        exampleSets: {
            ...state.exampleSets
        }
    };
    delete newState.exampleSets[id];
    return newState;
}
function updateStateWithExecution(state, action) {
    return {
        ...state,
        executions: {
            ...state.executions,
            [action.id]: action
        }
    };
}
function deleteExecutionFromState(state, id) {
    const newState = {
        ...state,
        executions: {
            ...state.executions
        }
    };
    delete newState.executions[id];
    return newState;
}
function updateStateWithResult(state, action) {
    return {
        ...state,
        results: {
            ...state.results,
            [action.id]: action
        }
    };
}
function updateStateWithResultData(state, action) {
    return {
        ...state,
        resultData: {
            ...state.resultData,
            [action.id]: action
        }
    };
}
function updateStateWithExecutionWorkflow(state, action) {
    return {
        ...state,
        executionWorkflow: {
            ...state.executionWorkflow,
            [action.execution_id]: action
        }
    };
}
function updateStateWithIsFetchingExecutionWorkflow(state, id, val) {
    return {
        ...state,
        isFetchingExecutionWorkflow: {
            ...state.isFetchingExecutionWorkflow,
            [id]: val
        }
    };
}
function deleteResultFromState(state, id) {
    const newState = {
        ...state,
        results: {
            ...state.results
        }
    };
    delete newState.results[id];
    return newState;
}
const initialState = {
    collections: {},
    exampleSets: {},
    executions: {},
    results: {},
    resultData: {},
    executionWorkflow: {},
    isFetchingExecutionWorkflow: {}
};
const reducers = {
    updateCollection(state, { payload }) {
        return updateStateWithCollection(state, payload);
    },
    updateCollections(state, { payload }) {
        return payload.reduce(updateStateWithCollection, state);
    },
    deleteCollection(state, { payload }) {
        return deleteCollectionFromState(state, payload);
    },
    updateExampleSet(state, { payload }) {
        return updateStateWithExampleSet(state, payload);
    },
    updateExampleSets(state, { payload }) {
        return payload.reduce(updateStateWithExampleSet, state);
    },
    deleteExampleSet(state, { payload }) {
        return deleteExampleSetFromState(state, payload);
    },
    updateExecution(state, { payload }) {
        return updateStateWithExecution(state, payload);
    },
    updateExecutions(state, { payload }) {
        return payload.reduce(updateStateWithExecution, state);
    },
    deleteExecution(state, { payload }) {
        return deleteExecutionFromState(state, payload);
    },
    updateResult(state, { payload }) {
        return updateStateWithResult(state, payload);
    },
    updateResults(state, { payload }) {
        return payload.reduce(updateStateWithResult, state);
    },
    deleteResult(state, { payload }) {
        return deleteResultFromState(state, payload);
    },
    updateResultData(state, { payload }) {
        return updateStateWithResultData(state, payload);
    },
    updateExecutionWorkflow(state, { payload }) {
        return updateStateWithExecutionWorkflow(state, payload);
    },
    updateIsFetchingExecutionWorkflow(state, { payload }) {
        return updateStateWithIsFetchingExecutionWorkflow(state, payload.id, payload.val);
    }
};
// @ts-ignore
const contentGenerationSlice = createSlice({
    name: "exampleSet",
    initialState,
    reducers
});
export default contentGenerationSlice.reducer;
function getBase(state) {
    return state.contentGeneration;
}
export function getCollections(state) {
    return getBase(state).collections;
}
export function getCollectionById(state, id) {
    return getBase(state).collections[id];
}
export function getExampleSets(state) {
    return getBase(state).exampleSets;
}
export function filterExampleSets(exampleSets, folderId) {
    return Object.values(exampleSets).filter((example) => !example.metadata.is_hidden && (folderId === undefined || example.folder_id === folderId));
}
export function getExampleSetById(state, id) {
    return getBase(state).exampleSets[id];
}
export function getExecutions(state) {
    return getBase(state).executions;
}
export function getExecutionById(state, id) {
    return getBase(state).executions[id];
}
export function getResults(state) {
    return getBase(state).results;
}
export function getResultById(state, id) {
    return getBase(state).results[id];
}
export function getResultData(state) {
    return getBase(state).resultData;
}
export function getExecutionWorkflow(state) {
    return getBase(state).executionWorkflow;
}
export function getExecutionWorkflowById(state, executionId) {
    return getBase(state).executionWorkflow[executionId];
}
export function getIsFetchingExecutionWorkflow(state) {
    return getBase(state).isFetchingExecutionWorkflow;
}
export function getIsFetchingExecutionWorkflowById(state, executionId) {
    return getBase(state).isFetchingExecutionWorkflow[executionId];
}
export function createCollection(post) {
    return async (dispatch) => {
        const collection = await client.createCollection(post);
        dispatch(contentGenerationSlice.actions.updateCollection(collection));
        return collection;
    };
}
export function updateCollection(id, post) {
    return async (dispatch) => {
        const collection = await client.updateCollection(id, post);
        dispatch(contentGenerationSlice.actions.updateCollection(collection));
        return collection;
    };
}
export function fetchCollections(query) {
    return async (dispatch) => {
        const collections = await client.getCollections(query);
        dispatch(contentGenerationSlice.actions.updateCollections(collections));
        return collections;
    };
}
export function fetchCollectionById(id) {
    return async (dispatch) => {
        const collection = await client.getCollectionById(id);
        dispatch(contentGenerationSlice.actions.updateCollection(collection));
        return collection;
    };
}
export function fetchCollectionExecutions(collectionId) {
    return async (dispatch) => {
        const executions = await client.getCollectionExecutions(collectionId);
        dispatch(contentGenerationSlice.actions.updateExecutions(executions));
        return executions;
    };
}
export function fetchExecutionWorkflowPlan(executionId, autoGenerate = false) {
    return async (dispatch, getState) => {
        const account = accountsReducer.getSelectedAccount(getState());
        const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(account.id);
        let executionWorkflow;
        dispatch(updateIsFetchingExecutionWorkflowById(executionId, true));
        try {
            const response = await acf.getAgentExecutionClient().getExecutionWorkflowPlan(executionId, autoGenerate);
            executionWorkflow = {
                execution_id: Number(response.execution_id),
                success: response.success,
                data: response.data
            };
        }
        catch {
            console.log("Could not fetch executionWorkflow");
            dispatch(updateIsFetchingExecutionWorkflowById(executionId, false));
            return Promise.resolve();
        }
        dispatch(contentGenerationSlice.actions.updateExecutionWorkflow(executionWorkflow));
        dispatch(updateIsFetchingExecutionWorkflowById(executionId, false));
        return executionWorkflow;
    };
}
export function createExecutionWorkflowPlan(executionId, autoGenerate = false) {
    return async (dispatch, getState) => {
        const account = accountsReducer.getSelectedAccount(getState());
        const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(account.id);
        let executionWorkflow;
        dispatch(updateIsFetchingExecutionWorkflowById(executionId, true));
        try {
            const response = await acf.getAgentExecutionClient().createExecutionWorkflowPlan(executionId, autoGenerate);
            executionWorkflow = {
                execution_id: Number(response.execution_id),
                success: response.success,
                data: response.data
            };
        }
        catch {
            console.log("Could not create executionWorkflow");
            dispatch(updateIsFetchingExecutionWorkflowById(executionId, false));
            return Promise.resolve();
        }
        dispatch(contentGenerationSlice.actions.updateExecutionWorkflow(executionWorkflow));
        dispatch(updateIsFetchingExecutionWorkflowById(executionId, false));
        return executionWorkflow;
    };
}
export function deleteCollection(id) {
    return async (dispatch) => {
        const collection = await client.deleteCollection(id);
        if (collection.deleted === "DELETED") {
            dispatch(contentGenerationSlice.actions.deleteCollection(id));
        }
    };
}
export function updateIsFetchingExecutionWorkflowById(id, val) {
    return (dispatch) => {
        dispatch(contentGenerationSlice.actions.updateIsFetchingExecutionWorkflow({ id, val }));
    };
}
export function createExampleSet(post) {
    return async (dispatch) => {
        const exampleSet = await client.createExampleSet(post);
        dispatch(contentGenerationSlice.actions.updateExampleSet(exampleSet));
        return exampleSet;
    };
}
export function updateExampleSet(id, post) {
    return async (dispatch) => {
        const exampleSet = await client.updateExampleSet(id, post);
        dispatch(contentGenerationSlice.actions.updateExampleSet(exampleSet));
        return exampleSet;
    };
}
export function addExecutionsToExampleSet(exampleSetId, resultsArray) {
    return async (dispatch) => {
        if (!resultsArray.length) {
            return dispatch(fetchExampleSetById(exampleSetId));
        }
        let result;
        const promises = resultsArray.map(async (resultId) => {
            result = await dispatch(addExecutionToExampleSet(exampleSetId, Number(resultId)));
        });
        return Promise.all(promises).then(async () => {
            result = await dispatch(fetchExampleSetById(exampleSetId));
            return result;
        });
    };
}
export function addSyntheticDataToExampleSet(exampleSetId, modelId, synthDataCount) {
    return (dispatch, getState) => {
        const accountId = getSelectedAccountId(getState());
        return AibleClientFactory.getInstance()
            .getAccountClient()
            .getCustomerClientFactory(accountId)
            .then((factory) => factory.getContentGenerationClient().generateExampleSetData(exampleSetId, modelId, synthDataCount))
            .then(() => dispatch(fetchExampleSetById(exampleSetId)));
    };
}
export function addExecutionToExampleSet(exampleSetId, resultId) {
    return async (dispatch) => {
        const exampleSet = await client.addExampleSetResultLink(exampleSetId, resultId);
        dispatch(contentGenerationSlice.actions.updateExampleSet(exampleSet));
        return exampleSet;
    };
}
export function fetchExampleSets(query) {
    return async (dispatch) => {
        dispatch(globalReducer.updateIsExampleSetsLoading(true));
        const exampleSets = await client.getExampleSets(query);
        dispatch(contentGenerationSlice.actions.updateExampleSets(exampleSets));
        dispatch(globalReducer.updateIsExampleSetsLoading(false));
        return exampleSets;
    };
}
export function fetchExampleSetById(id) {
    return async (dispatch) => {
        const exampleSet = await client.getExampleSetById(id);
        dispatch(contentGenerationSlice.actions.updateExampleSet(exampleSet));
        return exampleSet;
    };
}
export function fetchExampleSetViewAndUpdate(id) {
    return async (dispatch) => {
        const exampleSet = await client.getExampleSetById(id);
        const resultsView = await client.getExampleSetResultView(id);
        const update = {
            ...exampleSet,
            result_ids: resultsView.result_ids
        };
        dispatch(contentGenerationSlice.actions.updateExampleSet(update));
        return exampleSet;
    };
}
export function fetchResultByIdAndUpdate(id) {
    return async (dispatch, getState) => {
        const accountId = getSelectedAccountId(getState());
        const accountClient = AibleClientFactory.getInstance().getAccountClient();
        const customerContentGenerationClient = (await accountClient.getCustomerClientFactory(accountId)).getContentGenerationClient();
        const result = await customerContentGenerationClient.getResult(id);
        console.log("Fetched result: ", id, result);
        dispatch(contentGenerationSlice.actions.updateResultData(result));
        return result;
    };
}
export function deleteExampleSet(id) {
    return async (dispatch) => {
        const exampleSet = await client.deleteExampleSet(id);
        if (exampleSet.deleted === "DELETED") {
            dispatch(contentGenerationSlice.actions.deleteExampleSet(id));
        }
    };
}
export function createExecution(post) {
    return async (dispatch) => {
        const execution = await client.createExecution(post);
        dispatch(contentGenerationSlice.actions.updateExecution(execution));
        return execution;
    };
}
export function updateExecution(id, post) {
    return async (dispatch) => {
        const execution = await client.updateExecution(id, post);
        dispatch(contentGenerationSlice.actions.updateExecution(execution));
        return execution;
    };
}
export function fetchExecutions(query) {
    return async (dispatch) => {
        const executions = await client.getExecutions(query);
        dispatch(contentGenerationSlice.actions.updateExecutions(executions));
        return executions;
    };
}
export function fetchExecutionById(id) {
    return async (dispatch) => {
        const execution = await client.getExecutionById(id);
        dispatch(contentGenerationSlice.actions.updateExecution(execution));
        return execution;
    };
}
export function fetchExecutionResults(id) {
    return async (dispatch) => {
        const results = await client.getExecutionResults(id);
        dispatch(contentGenerationSlice.actions.updateResults(results));
        return results;
    };
}
export function deleteExecution(id) {
    return async (dispatch) => {
        const execution = await client.deleteExecution(id);
        if (execution.deleted === "DELETED") {
            dispatch(contentGenerationSlice.actions.deleteExecution(id));
        }
    };
}
export function createResult(executionId) {
    return async (dispatch) => {
        const result = await client.createResult(executionId);
        dispatch(contentGenerationSlice.actions.updateResult(result));
        return result;
    };
}
export function fetchResults(query) {
    return async (dispatch) => {
        const results = await client.getResults(query);
        dispatch(contentGenerationSlice.actions.updateResults);
        return results;
    };
}
export function fetchResultById(id) {
    return async (dispatch) => {
        const result = await client.getResultById(id);
        dispatch(contentGenerationSlice.actions.updateResult(result));
        return result;
    };
}
export function deleteResult(id) {
    return async (dispatch) => {
        const result = await client.deleteResult(id);
        if (result.deleted === "DELETED") {
            dispatch(contentGenerationSlice.actions.deleteResult(id));
        }
    };
}
